import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

export const navigateBack = () => {
    window.history.back();
};

export const navigateForward = () => {
    window.history.forward();
};

export const navigateSafely = (
    navigate: NavigateFunction,
    to: To,
    options?: NavigateOptions
): void => {
    const navigation = options === undefined ? navigate(to) : navigate(to, options);
    if (navigation instanceof Promise) {
        navigation.catch(() => undefined);
    }
};

export const runSafely = (action: () => Promise<unknown>): void => {
    action().catch(() => undefined);
};
